// import config
import axios from "../config/axios";

export const addFuturePair = async (data) => {
    try {
        let respData = await axios({
            'method': 'post',
            'url': `/adminapi/futurePair`,
            'data': data
        });
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}

export const futurePairList = async (data) => {
    try {
        let respData = await axios({
            'method': 'get',
            'url': `/adminapi/futurePair`,
            'params': data
        });
        return {
            status: "success",
            loading: false,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            error: err.response.data.errors
        }
    }
}

export const editFuturePair = async (data) => {
    try {
        let respData = await axios({
            'method': 'put',
            'url': `/adminapi/futurePair`,
            'data': data
        });
        return {
            status: "success",
            loading: false,
            message: respData.data.message,
            result: respData.data.result
        }
    } catch (err) {
        return {
            status: "failed",
            loading: false,
            message: err.response.data.message,
            error: err.response.data.errors
        }
    }
}